import { Text } from "@chakra-ui/react";

export default function SectionDescription({ text }: { text: string }) {
  return (
    <Text fontSize="14px" lineHeight="22px" mb="24px">
      {text}
    </Text>
  );
}
